import React, { useEffect, useReducer, useCallback, useState, useRef } from "react";
import {
  Row,
  Col,
  Select,
  Button,
  Popconfirm,
  Tooltip,
  Table,
  Input,
  Form,
  Modal,
  Divider,
  Typography,
  InputNumber,
  DatePicker,
  notification,
  Card,
  Spin,
  Checkbox,
  Dropdown,
  Menu,
  Alert,

} from "antd";
import * as XLSX from "xlsx";
import {
  CloseCircleFilled,
  DeleteFilled,
  ExportOutlined,
  PlusCircleOutlined,
  SyncOutlined,
  MedicineBoxOutlined,
  DownOutlined,
  UploadOutlined,
  ImportOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "../Pages/CSS/Traitement.css";
import { BpiService } from "../Services/BpiService";
import { SuspensionsService } from "../Services/SuspensionsService";
import { ExerciceDocService } from "../Services/ExerciceDocService";
import { DocumentService } from "../Services/DocumentService";
import TableDOc from "./TableDoc";
import { AdherentsService } from "../Services/AdherentsService";
import { ParticipantsIpmService } from "../Services/ParticipantsIpmService";
import { TypesBenefsService } from "../Services/TypesBenefsServices";
import { ListFournisService } from "../Services/ListFournisService";
import { SpecialitesService } from "../Services/SpecialitesService";
import dayjs from "dayjs";
const { Option } = Select;
const { Title, Text } = Typography;
const { confirm } = Modal;

const bpiService = new BpiService();
const documentService = new DocumentService();
const suspensionsService = new SuspensionsService();
const exerciceDocService = new ExerciceDocService();
const adherentsService = new AdherentsService();
const participantsIpmService = new ParticipantsIpmService();
const specialistesService = new SpecialitesService();
const typesBenefsService = new TypesBenefsService();
const fournisseurService = new ListFournisService();

const userProfil = localStorage.getItem("profil");

// Colonnes attendues (noms et ordre) dans le fichier Excel d'import des bons
const IMPORT_TEMPLATE_COLUMNS = [
  "numdoc",
  "datedoc",
  "codesoc",
  "matripart",
  "matribenef",
  "codefourn",
  "typebenef",
  "montdoc",
];

// Parse une valeur de cellule date (Date Excel, ISO ou DD/MM/YYYY) en objet dayjs, sans plugin customParseFormat
const parseImportDate = (value) => {
  if (value === "" || value === undefined || value === null) return null;
  if (dayjs.isDayjs(value)) return value.isValid() ? value : null;

  if (value instanceof Date) {
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const parsed = dayjs(raw);
    return parsed.isValid() ? parsed : null;
  }

  const frMatch = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (frMatch) {
    const [, dd, mm, yyyy] = frMatch;
    const parsed = dayjs(`${yyyy}-${mm}-${dd}`);
    return parsed.isValid() ? parsed : null;
  }

  return null;
};

const initialState = {
  selectedYear: new Date().getFullYear().toString(),
  addedRows: [],
  tableData: [],
  selectedOption: "KO",
  selectedTypeDoc: "BPI",
  filteredData: [],
  participantsData: null,
  isTableVisible: false,
  refreshTable: false,
  isRefreshing: false,
  medicamentsData: null,
  loading: false,
  benefsData: null,
  isSaisirMedicamentClicked: false,
  specialitesData: null,
  isEdit: false,
  prescripteursData: [],
  pharmaciesData: [],
  isMatriculeSelected: false,
  isBeneficiaireSelected: false,
  beneficiaires: [],
  isDateSelected: false,
  selectedRowData: null,
  addedMedicaments: [],
  isPrescripteurSelectEnabled: false,
  adherents: [],
  allBeneficiaires: [],
  years: [],
  isModalVisible: false,
  isSocieteSelectEnabled: true,
  isMatriculeSelectEnabled: false,
  isBeneficiaireSelectEnabled: false,
  isModalLoading: true,
  loadPharmacyData: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "SET_SELECTED_YEAR":
      return { ...state, selectedYear: action.payload };
    case "SET_ADDED_ROWS":
      return { ...state, addedRows: action.payload };
    case "SET_TABLE_DATA":
      return { ...state, tableData: action.payload };
    case "SET_SELECTED_OPTION":
      return { ...state, selectedOption: action.payload };
    case "SET_FILTERED_DATA":
      return { ...state, filteredData: action.payload };
    case "SET_PARTICIPANTS_DATA":
      return { ...state, participantsData: action.payload };
    case "SET_IS_TABLE_VISIBLE":
      return { ...state, isTableVisible: action.payload };
    case "SET_REFRESH_TABLE":
      return { ...state, refreshTable: action.payload };
    case "SET_MEDICAMENTS_DATA":
      return { ...state, medicamentsData: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_BENEF_DATA":
      return { ...state, benefsData: action.payload };
    case "SET_IS_SAISIR_MEDICAMENT_CLICKED":
      return { ...state, isSaisirMedicamentClicked: action.payload };
    case "SET_SPECIALITES_DATA":
      return { ...state, specialitesData: action.payload };
    case "SET_IS_EDIT":
      return { ...state, isEdit: action.payload };
    case "SET_PRESCRIPTEURS_DATA":
      return { ...state, prescripteursData: action.payload };
    case "SET_PHARMACIES_DATA":
      return { ...state, pharmaciesData: action.payload };
    case "SET_IS_MATRICULE_SELECTED":
      return { ...state, isMatriculeSelected: action.payload };
    case "SET_IS_BENEFICIAIRE_SELECTED":
      return { ...state, isBeneficiaireSelected: action.payload };
    case "SET_BENEFICIAIRES":
      return { ...state, beneficiaires: action.payload };
    case "SET_IS_DATE_SELECTED":
      return { ...state, isDateSelected: action.payload };
    case "SET_SELECTED_ROW_DATA":
      return { ...state, selectedRowData: action.payload };
    case "SET_ADDED_MEDICAMENTS":
      return { ...state, addedMedicaments: action.payload };
    case "SET_IS_PRESCRIPTEUR_SELECT_ENABLED":
      return { ...state, isPrescripteurSelectEnabled: action.payload };
    case "SET_ADHERENTS":
      return { ...state, adherents: action.payload };
    case "SET_ALL_BENEFICIAIRES":
      return { ...state, allBeneficiaires: action.payload };
    case "SET_FILTERED_DATA":
      return { ...state, filteredData: action.payload };
    case "SET_YEARS":
      return { ...state, years: action.payload };
    case "SET_IS_MODAL_VISIBLE":
      return { ...state, isModalVisible: action.payload };
    case "SET_IS_SOCIETE_SELECT_ENABLED":
      return { ...state, isSocieteSelectEnabled: action.payload };
    case "SET_IS_MATRICULE_SELECT_ENABLED":
      return { ...state, isMatriculeSelectEnabled: action.payload };
    case "SET_IS_REFRESHING":
      return { ...state, isRefreshing: action.payload };
    case "SET_IS_BENEFICIAIRE_SELECT_ENABLED":
      return { ...state, isBeneficiaireSelectEnabled: action.payload };
    case "SET_LOAD_PHARMACY_DATA":
      return { ...state, loadPharmacyData: action.payload };
    case "SET_IS_MODAL_LOADING":
      return { ...state, isModalLoading: action.payload };
    case "SET_PARTICIPANT_DETAILS":
      return { ...state, participantDetails: action.payload };
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
}

const BonsPharma = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isParticipantInactive, setIsParticipantInactive] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [isBonManuel, setIsBonManuel] = useState(false); // État pour la case à cocher "Bon Manuel"
  const [api, notificationHolder] = notification.useNotification();
  const [loadingValid, setLoadingValid] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [columnFilteredData, setColumnFilteredData] = useState([]);
  const [isImportModalVisible, setIsImportModalVisible] = useState(false);
  const [importRows, setImportRows] = useState([]);
  const [importErrors, setImportErrors] = useState([]);
  const [importResults, setImportResults] = useState(null);
  const [isImporting, setIsImporting] = useState(false);
  const importFileInputRef = useRef(null);
  const chargesIPMSet = useRef(new Set());
  const endettementSet = useRef(new Set());

  const userRoleName = localStorage.getItem("role_name");
  const [form] = Form.useForm();


  const fetchData = useCallback(async () => {
    try {
      const yearsData = await exerciceDocService.getAllExercicesDoc();
      dispatch({ type: "SET_YEARS", payload: yearsData });
      //   await fetchDataByOption(state.selectedOption);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  }, [/* state.selectedYear, state.selectedOption */]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchDataByOption(state.selectedOption);
  }, [state.selectedYear, state.selectedTypeDoc, state.selectedOption]);

  const handleDeleteline = async (numdoc) => {
    try {
      confirm({
        title: "Êtes-vous sûr de vouloir supprimer ce bon ?",
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await bpiService.deleteDoc(numdoc);
            const updatedData = state.filteredData.filter(
              (item) => item.numdoc !== numdoc
            );
            dispatch({ type: "SET_FILTERED_DATA", payload: updatedData });
            notification.success({
              message: "Succès",
              description: "Bon supprimée avec succès",
            });
          } catch (error) {
            notification.error({
              message: "Erreur",
              description: "Erreur lors de la suppression du document",
            });
          }
        },
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la confirmation de la suppression",
      });
    }
  };

  const handleDeleteSelectedDocuments = () => {
    if (selectedDocuments.length === 0) {
      notification.warning({
        message: "Aucune sélection",
        description: "Veuillez sélectionner au moins un document à supprimer",
      });
      return;
    }

    confirm({
      title: `Êtes-vous sûr de vouloir supprimer ${selectedDocuments.length} document(s) ?`,
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          await documentService.deleteListDocument(selectedDocuments);
          const deletedNumdocs = selectedDocuments.map((doc) => doc.numdoc);
          const updatedData = state.filteredData.filter(
            (item) => !deletedNumdocs.includes(item.numdoc)
          );
          dispatch({ type: "SET_FILTERED_DATA", payload: updatedData });
          setSelectedDocuments([]);
          notification.success({
            message: "Succès",
            description: "Document(s) supprimé(s) avec succès",
          });
        } catch (error) {
          notification.error({
            message: "Erreur",
            description: "Erreur lors de la suppression des documents sélectionnés",
          });
        }
      },
    });
  };

  const fetchDataByOption = async (option) => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const data = await bpiService.getAllBci(state.selectedTypeDoc, option, state.selectedYear);

      const filteredData = (userRoleName === "Point_Focal" || userRoleName === "Point Focal")
        ? data.filter(item => item.user_id === userId)
        : data;
      dispatch({ type: "SET_TABLE_DATA", payload: filteredData });
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "SET_LOADING", payload: false });
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des données",
      });
    }
  };

  useEffect(() => {
    dispatch({ type: "SET_FILTERED_DATA", payload: state.tableData });
  }, [state.tableData, state.refreshTable]);

  const handleSocieteChange = async (value) => {
    try {
      let participantsData;
      if (!state.isEdit) {
        participantsData = await participantsIpmService.getOneListtParticipant(
          value
        );
      } else {
        participantsData = await participantsIpmService.getOneEtParticipant(
          value
        );
      }
      dispatch({ type: "SET_PARTICIPANTS_DATA", payload: participantsData });
      dispatch({ type: "SET_IS_MATRICULE_SELECT_ENABLED", payload: false });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description:
          "Erreur lors de la récupération des données du participant",
      });
    }
  };

  const handleTypeBenefChange = async (value) => {
    try {
      const filteredBeneficiaires = state.allBeneficiaires.filter(
        (beneficiaire) => beneficiaire.codebenef === value
      );
      if (filteredBeneficiaires.length === 0) {
        form.setFieldsValue({
          matribenef: undefined,
        });
        dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
      } else {
        dispatch({ type: "SET_BENEFICIAIRES", payload: filteredBeneficiaires });
        dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: true });
        form.setFieldsValue({
          matribenef: filteredBeneficiaires[0].matribenef,
        });
      }
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors du filtrage des bénéficiaires",
      });
    }
  };

  const handleSelectChange = (value) => {
    dispatch({ type: "SET_SELECTED_OPTION", payload: value });
  };

  const handleYearChange = (value) => {
    dispatch({ type: "SET_SELECTED_YEAR", payload: value });
  };

  const fetchTypeBenef = async () => {
    try {
      const typeBenefData = await typesBenefsService.getAllTypesBenefs();
      dispatch({ type: "SET_BENEF_DATA", payload: typeBenefData });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };


  const handleMatPartChange = async (value) => {
    try {
      const participantData = await participantsIpmService.getOneParticipant(value);

      if (participantData.suspension_part === "S") {
        setSelectedParticipant(participantData);
        setIsParticipantInactive(true);
        return;
      }

      if (participantData.suspension_adht) {
        Modal.confirm({
          title: "Société suspendue!",
          content: "Voulez-vous confirmer cette opération malgré la suspension?",
          okText: "Valider",
          cancelText: "Annuler",
          onOk: async () => {
            proceedWithMatPartChange(value);
          },
          onCancel: () => {
            form.resetFields(["matripart"]);
          },
        });
        return;
      }

      if (chargesIPMSet.current.has(value)) {
        if (userProfil === "role_1" || userProfil === "role_2") {
          Modal.confirm({
            title: "Dépassement de charges IPM !",
            content: "Ce participant a dépassé son seuil de charges IPM. Voulez-vous continuer la saisie ?",
            okText: "Continuer",
            cancelText: "Annuler",
            okButtonProps: { danger: true },
            onOk: () => proceedWithMatPartChange(value),
            onCancel: () => form.resetFields(["matripart"]),
          });
        } else {
          Modal.warning({
            title: "Dépassement de charges IPM !",
            content: "Ce participant a dépassé son seuil de charges IPM. Veuillez vous référer au gérant.",
            okText: "Fermer",
            onOk: () => form.resetFields(["matripart"]),
          });
        }
        return;
      }

      if (endettementSet.current.has(value)) {
        if (userProfil === "role_1" || userProfil === "role_2") {
          Modal.confirm({
            title: "Dépassement d'endettement !",
            content: "Ce participant a dépassé son seuil d'endettement. Voulez-vous continuer la saisie ?",
            okText: "Continuer",
            cancelText: "Annuler",
            okButtonProps: { danger: true },
            onOk: () => proceedWithMatPartChange(value),
            onCancel: () => form.resetFields(["matripart"]),
          });
        } else {
          Modal.warning({
            title: "Dépassement d'endettement !",
            content: "Ce participant a dépassé son seuil d'endettement. Veuillez vous référer au gérant.",
            okText: "Fermer",
            onOk: () => form.resetFields(["matripart"]),
          });
        }
        return;
      }

      proceedWithMatPartChange(value);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des données du participant",
      });
    }
  };

  // Fonction pour exécuter les actions après validation
  const proceedWithMatPartChange = async (value) => {
    try {
      const benefData = await participantsIpmService.getBenefParticipant(value);
      dispatch({ type: "SET_IS_MATRICULE_SELECTED", payload: true });
      dispatch({ type: "SET_ALL_BENEFICIAIRES", payload: benefData });
      dispatch({ type: "SET_BENEFICIAIRES", payload: benefData });
      dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
      dispatch({ type: "SET_PARTICIPANT_DETAILS", payload: selectedParticipant });
      form.setFieldsValue({
        codetype: undefined,
        matribenef: undefined,
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des bénéficiaires",
      });
    }
  };



  const handleFournisseurChange = async (value) => {
    try {
      const allFournisseurs = await fournisseurService.getAllListFournis();
      const prescripteurs = allFournisseurs.filter(
        (fournisseur) => fournisseur.codespe === value
      );
      const pharmacies = allFournisseurs
        .filter((fournisseur) => fournisseur.codespe === "06")
        .map((pharmacie) => ({
          ...pharmacie,
          exclus: pharmacie.exclus !== undefined ? pharmacie.exclus : false, // Assurez-vous que 'exclus' est bien défini
        }));
      dispatch({ type: "SET_PRESCRIPTEURS_DATA", payload: prescripteurs });
      dispatch({
        type: "SET_IS_PRESCRIPTEUR_SELECT_ENABLED",
        payload: !!value,
      });
      dispatch({ type: "SET_PHARMACIES_DATA", payload: pharmacies });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des prescripteurs",
      });
    }
  };

  const handleSearch = (value) => {
    const filtered = state.tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    dispatch({ type: "SET_FILTERED_DATA", payload: filtered });
  };



  const fetchAdherents = async () => {
    try {
      const isPointFocal =
        userRoleName === "Point_Focal" || userRoleName === "Point Focal";

      const adherentsData = isPointFocal
        ? await adherentsService.getAllAdherentsForPointFocal(userId)
        : await adherentsService.getAllAdherents();

      // Filtrer les adhérents pour exclure ceux qui ont suspension_adht à true
      const filteredAdherents = adherentsData.filter(
        (adherent) => !adherent.suspension_adht
      );

      dispatch({ type: "SET_ADHERENTS", payload: filteredAdherents });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };


  const fetchFournis = async () => {
    try {
      const fournisseurs = await fournisseurService.getAllListFournis();
      const pharmacies = fournisseurs.filter(
        (fournisseur) => fournisseur.codespe === "06"
      );
      dispatch({ type: "SET_PHARMACIES_DATA", payload: pharmacies });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const fetchSpecialite = async () => {
    try {
      const specialites = await specialistesService.getAllSpecialites();
      dispatch({ type: "SET_SPECIALITES_DATA", payload: specialites });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const fetchMedoc = async (value) => {
    try {
      const medicaments = await participantsIpmService.getMedicamentList();
      dispatch({ type: "SET_MEDICAMENTS_DATA", payload: medicaments });
      //dispatch({ type: "SET_IS_SAISIR_MEDICAMENT_CLICKED", payload: !!value });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const handleMedoc = async (value) => {



    dispatch({ type: "SET_IS_SAISIR_MEDICAMENT_CLICKED", payload: !!value });

  };

  const handleDateChange = (value) => {
    dispatch({ type: "SET_IS_DATE_SELECTED", payload: !!value });
    fetchMedoc()

  };

  const handleRefresh = async () => {
    dispatch({ type: "SET_IS_REFRESHING", payload: true });

    try {
      await fetchDataByOption(state.selectedOption);
      dispatch({ type: "SET_REFRESH_TABLE", payload: !state.refreshTable });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la rafraîchissement des données",
      });
    } finally {
      dispatch({ type: "SET_IS_REFRESHING", payload: false });
    }
  };

  const handleExportClick = () => {
    if (!Array.isArray(columnFilteredData) || columnFilteredData.length === 0) {
      notification.warning({
        message: "Aucune donnée",
        description: "Il n'y a aucune donnée à exporter",
      });
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(columnFilteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ExportData");

    XLSX.writeFile(workbook, "export.xlsx");
  };

  const handleOpenImportModal = () => {
    setImportRows([]);
    setImportErrors([]);
    setImportResults(null);
    setIsImportModalVisible(true);
  };

  const handleCloseImportModal = () => {
    setIsImportModalVisible(false);
    setImportRows([]);
    setImportErrors([]);
    setImportResults(null);
    if (importFileInputRef.current) {
      importFileInputRef.current.value = "";
    }
  };

  const handleImportFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array", cellDates: true });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });

        if (rawRows.length === 0) {
          setImportRows([]);
          setImportErrors([{ rowNum: "-", field: "-", message: "Le fichier est vide." }]);
          return;
        }

        const headerRow = rawRows[0].map((h) => (h || "").toString().trim());
        const missingColumns = IMPORT_TEMPLATE_COLUMNS.filter((col) => !headerRow.includes(col));

        if (missingColumns.length > 0) {
          setImportRows([]);
          setImportErrors([{
            rowNum: "-",
            field: "-",
            message: `Colonne(s) manquante(s) : ${missingColumns.join(", ")}. Merci d'utiliser le modèle fourni.`,
          }]);
          return;
        }

        const dataRows = rawRows
          .slice(1)
          .filter((row) => row.some((cell) => cell !== "" && cell !== undefined && cell !== null));

        const parsedRows = [];
        const errors = [];

        dataRows.forEach((row, idx) => {
          const excelRowNum = idx + 2; // ligne 1 = entêtes
          const rowObj = { __rowNum: excelRowNum };

          IMPORT_TEMPLATE_COLUMNS.forEach((col) => {
            const colIndex = headerRow.indexOf(col);
            const cellValue = row[colIndex];
            rowObj[col] = cellValue === undefined || cellValue === null ? "" : cellValue;
          });

          IMPORT_TEMPLATE_COLUMNS.forEach((col) => {
            const value = rowObj[col];
            const isEmpty = value === "" || value === undefined || value === null;
            if (isEmpty) {
              errors.push({ rowNum: excelRowNum, field: col, message: `Cellule vide (${col})` });
            }
          });

          if (rowObj.datedoc !== "") {
            const parsedDate = parseImportDate(rowObj.datedoc);
            if (!parsedDate) {
              errors.push({
                rowNum: excelRowNum,
                field: "datedoc",
                message: `Date incorrecte : "${rowObj.datedoc}" (formats acceptés : YYYY-MM-DD ou DD/MM/YYYY)`,
              });
            } else {
              rowObj.datedoc = parsedDate.format("YYYY-MM-DD");
            }
          }

          if (rowObj.montdoc !== "" && Number.isNaN(Number(rowObj.montdoc))) {
            errors.push({
              rowNum: excelRowNum,
              field: "montdoc",
              message: `Montant invalide : "${rowObj.montdoc}"`,
            });
          }

          parsedRows.push(rowObj);
        });

        setImportRows(parsedRows);
        setImportErrors(errors);
        setImportResults(null);
      } catch (error) {
        console.error("Erreur lors de la lecture du fichier :", error);
        setImportRows([]);
        setImportErrors([{
          rowNum: "-",
          field: "-",
          message: "Fichier illisible. Vérifiez qu'il s'agit bien d'un fichier Excel (.xlsx).",
        }]);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleExportImportErrors = () => {
    if (importErrors.length === 0) return;

    const dataToExport = importErrors.map((err) => ({
      "Ligne Excel": err.rowNum,
      Colonne: err.field,
      Anomalie: err.message,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Anomalies");
    XLSX.writeFile(workbook, "anomalies_import_bons.xlsx");
  };

  const handleExportImportFailures = () => {
    const failures = (importResults || []).filter((r) => !r.success);
    if (failures.length === 0) return;

    const dataToExport = failures.map((r) => ({
      "Ligne Excel": r.rowNum,
      "N° Bon": r.numdoc,
      Détail: r.message,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Echecs");
    XLSX.writeFile(workbook, "echecs_import_bons.xlsx");
  };

  const handleConfirmImport = async () => {
    if (importRows.length === 0 || importErrors.length > 0 || isImporting) return;

    setIsImporting(true);
    const results = [];

    for (const row of importRows) {
      try {
        const docData = {
          numdoc: row.numdoc,
          datedoc: row.datedoc,
          codesoc: row.codesoc,
          matripart: row.matripart,
          matribenef: row.matribenef,
          codefourn: row.codefourn,
          typebenef: row.typebenef,
          montdoc: Number(row.montdoc),
          // Champs retirés du template Excel : valeurs par défaut fixes, conservées dans le document
          typedoc: "BPI",
          codepresc: "99999",
          etat: "KO",
          codeprest: "06",
          natprest: "06",
          naturedoc: "Manuel",
          user_id: userId,
        };

        const response = await bpiService.AddDoc(docData);

        if (response?.Added === false) {
          results.push({
            rowNum: row.__rowNum,
            numdoc: row.numdoc,
            success: false,
            message: "Numéro de bon déjà ajouté.",
          });
        } else {
          results.push({
            rowNum: row.__rowNum,
            numdoc: row.numdoc,
            success: true,
            message: "Importé avec succès.",
          });
        }
      } catch (error) {
        results.push({
          rowNum: row.__rowNum,
          numdoc: row.numdoc,
          success: false,
          message: error?.response?.data?.message || "Erreur lors de l'import de cette ligne.",
        });
      }
    }

    setImportResults(results);
    setIsImporting(false);
    fetchDataByOption(state.selectedOption);
  };

  const handleAddRow = () => {
    const values = form.getFieldsValue();
    const { codeacte, qte, prix_unitaire } = values;
    const freel = qte * prix_unitaire;

    if (state.addedMedicaments.includes(codeacte)) {
      notification.warning({
        message: "Duplication",
        description: "Ce médicament a déjà été ajouté à la table.",
      });
      return;
    }

    // Trouvez le médicament correspondant à libacte pour obtenir la valeur de exclus
    const medicament = state.medicamentsData.find(
      (med) => med.codeacte === codeacte
    );
    const exclus = medicament ? medicament.exclus : false; // Utilisez la valeur de exclus du médicament ou false par défaut

    const newRow = {
      numero: state.addedRows.length + 1,
      codeacte,
      libacte: medicament.libacte,
      qte,
      prix_unitaire,
      freel,
      exclus, // Utilisez la valeur dynamique de exclus
    };

    dispatch({ type: "SET_ADDED_ROWS", payload: [...state.addedRows, newRow] });
    dispatch({
      type: "SET_ADDED_MEDICAMENTS",
      payload: [...state.addedMedicaments, codeacte],
    });
    dispatch({ type: "SET_IS_TABLE_VISIBLE", payload: true });
    form.setFieldsValue({
      qteTotal: isNaN(values.qteTotal) ? qte : values.qteTotal + qte,
    });
    form.resetFields(["codeacte", "qte", "prix_unitaire"]);
  };

  const handleDelete = (record) => {
    const updatedRows = state.addedRows.filter(
      (row) => row.numero !== record.numero
    );
    dispatch({ type: "SET_ADDED_ROWS", payload: updatedRows });
  };

  const handleClearTable = () => {
    dispatch({ type: "SET_ADDED_ROWS", payload: [] });
    dispatch({ type: "SET_ADDED_MEDICAMENTS", payload: [] });
  };

  const loadChargesIPM = async () => {
    try {
      const data = await suspensionsService.getChargesIPM(state.selectedYear);
      chargesIPMSet.current = new Set(data.map(r => r.numcont).filter(Boolean));
    } catch {
      chargesIPMSet.current = new Set();
    }
  };

  const loadEndettement = async () => {
    try {
      const data = await suspensionsService.getSuspensionsEndettement(state.selectedYear);
      endettementSet.current = new Set(data.map(r => r.numcont).filter(Boolean));
    } catch {
      endettementSet.current = new Set();
    }
  };

  const handleOpenModal = (isManual = false) => {
    setIsBonManuel(isManual); // Définir l'état selon le type de bon
    dispatch({ type: "SET_IS_MODAL_VISIBLE", payload: true });
    dispatch({ type: "SET_IS_MODAL_LOADING", payload: true });

    // Charger les données nécessaires pour le modal
    Promise.all([
      fetchAdherents(),
      fetchTypeBenef(),
      fetchFournis(),
      fetchSpecialite(),
      loadChargesIPM(),
      loadEndettement(),
    ])
      .then(() => {
        dispatch({ type: "SET_IS_MODAL_LOADING", payload: false });
      })
      .catch((error) => {
        notification.error({
          message: "Erreur",
          description: "Erreur lors du chargement des données",
        });
        dispatch({ type: "SET_IS_MODAL_LOADING", payload: false });
      });
  };

  const handleLoadPharmacyData = (checked) => {
    dispatch({ type: "SET_LOAD_PHARMACY_DATA", payload: checked });

    if (checked) {

      fetchFournis()
        .then(() => {

        })
        .catch((error) => {
          notification.error({
            message: "Erreur",
            description: "Erreur lors du chargement des données de pharmacie",
          });

        });
    }
  };

  /*   const resetFormData = () => {
      form.resetFields(); // Réinitialiser les champs du formulaire
  
      // Réinitialiser les différents états à leurs valeurs initiales
      dispatch({ type: "SET_IS_TABLE_VISIBLE", payload: false });
      dispatch({ type: "SET_IS_PRESCRIPTEUR_SELECT_ENABLED", payload: false });
      dispatch({ type: "SET_IS_SAISIR_MEDICAMENT_CLICKED", payload: false });
      dispatch({ type: "SET_IS_MATRICULE_SELECTED", payload: false });
      dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
      dispatch({ type: "SET_IS_DATE_SELECTED", payload: false });
      dispatch({ type: "SET_SELECTED_ROW_DATA", payload: null });
      dispatch({ type: "SET_ADDED_ROWS", payload: [] });
      dispatch({ type: "SET_ADDED_MEDICAMENTS", payload: [] });
      dispatch({ type: "SET_IS_EDIT", payload: false });
      dispatch({ type: "SET_IS_SOCIETE_SELECT_ENABLED", payload: true });
      dispatch({ type: "SET_IS_MATRICULE_SELECT_ENABLED", payload: true });
      dispatch({ type: "SET_IS_BENEFICIAIRE_SELECT_ENABLED", payload: false });
  
     
    }; */

  const resetFormData = () => {
    // Conservez la valeur actuelle du champ Pharmacie
    const currentPharmacyValue = form.getFieldValue('codefourn');

    form.resetFields(); // Réinitialiser les champs du formulaire

    // Remettre la valeur de Pharmacie après la réinitialisation
    form.setFieldsValue({
      codefourn: currentPharmacyValue,
    });

    // Réinitialiser les différents états à leurs valeurs initiales
    dispatch({ type: "SET_IS_TABLE_VISIBLE", payload: false });
    dispatch({ type: "SET_IS_PRESCRIPTEUR_SELECT_ENABLED", payload: false });
    dispatch({ type: "SET_IS_SAISIR_MEDICAMENT_CLICKED", payload: false });
    dispatch({ type: "SET_IS_MATRICULE_SELECTED", payload: false });
    dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
    dispatch({ type: "SET_IS_DATE_SELECTED", payload: false });
    dispatch({ type: "SET_SELECTED_ROW_DATA", payload: null });
    dispatch({ type: "SET_ADDED_ROWS", payload: [] });
    dispatch({ type: "SET_ADDED_MEDICAMENTS", payload: [] });
    dispatch({ type: "SET_IS_EDIT", payload: false });
    dispatch({ type: "SET_IS_SOCIETE_SELECT_ENABLED", payload: true });
    dispatch({ type: "SET_IS_MATRICULE_SELECT_ENABLED", payload: true });
    dispatch({ type: "SET_IS_BENEFICIAIRE_SELECT_ENABLED", payload: false });
  };


  useEffect(() => {
    if (!state.isModalVisible) {
      resetFormData();
    }
  }, [state.isModalVisible]);

  const handleCloseModal = () => {
    dispatch({ type: "SET_IS_MODAL_VISIBLE", payload: false });
    dispatch({ type: "SET_IS_EDIT", payload: false });
    setIsBonManuel(false)
  };


  const handleEdit = async (record) => {
    // Stocker immédiatement le record sélectionné pour vérification ultérieure
    const currentRecordNumdoc = record.numdoc;

    dispatch({ type: "SET_IS_MODAL_VISIBLE", payload: true });
    dispatch({ type: "SET_IS_MODAL_LOADING", payload: true });
    dispatch({ type: "SET_IS_EDIT", payload: true });

    try {
      // Récupère les détails du document avec vérification de cohérence
      const details = await bpiService.GetDetailBpi(currentRecordNumdoc);

      // Vérifier que les détails correspondent bien au record demandé
      if (details.numdoc !== currentRecordNumdoc) {
        throw new Error("Incohérence dans les données récupérées");
      }

      const [
        adherentsData,
        participantsData,
        benefData,
        benefsData,
        specialites,
        prescripteursData,
        pharmaciesData,
      ] = await Promise.all([
        adherentsService.getAllAdherents(),
        participantsIpmService.getOneEtParticipant(record.codesoc),
        participantsIpmService.getBenefParticipant(record.matripart),
        typesBenefsService.getAllTypesBenefs(),
        specialistesService.getAllSpecialites(),
        fournisseurService.getAllListFournis(),
        fournisseurService.getAllListFournis(),
      ]);

      // Récupère les médicaments si besoin
      let medicamentsData = [];
      if (details.actes?.length > 0) {
        medicamentsData = await participantsIpmService.getMedicamentList();
      }

      // Prépare les données pour le formulaire et la table
      const selectedBenef = benefsData.find(benef => benef.codetype === details.typebenef);
      const codespe = details.codepresc?.slice(0, 2);
      const prescripteur = prescripteursData.find(p => p.numFourn === details.codepresc);

      const selectedRowData = {
        ...details,
        datepresc: details.datepresc ? dayjs(details.datepresc) : undefined,
        datedoc: details.datedoc ? dayjs(details.datedoc) : undefined,
        libtype: selectedBenef?.libtype,
        codespe,
        codepresc: prescripteur?.numFourn,
        montdoc: details.montdoc,
        remb_integral: details.remb_integral,
        // Ajouter un timestamp pour identifier clairement cette donnée
        _timestamp: Date.now(),
        _numdoc: currentRecordNumdoc
      };

      const addedRows = (details.actes || []).map((line, index) => ({
        numero: index + 1,
        codeacte: line.codeacte,
        libacte: line.libacte,
        qte: line.qte || 0,
        prix_unitaire: line.prix_unitaire || 0,
        freel: line.freel || 0,
        exclus: line.exclus || false,
        // Lier chaque ligne au document parent
        _parentNumdoc: currentRecordNumdoc
      }));

      // Vérifier une dernière fois que nous sommes toujours sur le bon record
      // avant de mettre à jour le state
      if (currentRecordNumdoc === record.numdoc) {
        // Dispatch toutes les données nécessaires
        dispatch({ type: "SET_SELECTED_ROW_DATA", payload: selectedRowData });
        dispatch({ type: "SET_ADHERENTS", payload: adherentsData });
        dispatch({ type: "SET_PARTICIPANTS_DATA", payload: participantsData });
        dispatch({ type: "SET_BENEFICIAIRES", payload: benefData });
        dispatch({ type: "SET_BENEF_DATA", payload: benefsData });
        dispatch({ type: "SET_SPECIALITES_DATA", payload: specialites });
        dispatch({ type: "SET_PRESCRIPTEURS_DATA", payload: prescripteursData });
        dispatch({ type: "SET_PHARMACIES_DATA", payload: pharmaciesData });
        dispatch({ type: "SET_MEDICAMENTS_DATA", payload: medicamentsData });
        dispatch({ type: "SET_ADDED_ROWS", payload: addedRows });
        dispatch({ type: "SET_IS_TABLE_VISIBLE", payload: addedRows.length > 0 });
        dispatch({ type: "SET_IS_MODAL_LOADING", payload: false });
      }
    } catch (error) {
      console.error("Erreur handleEdit:", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des détails",
      });
      dispatch({ type: "SET_IS_MODAL_LOADING", payload: false });

      // Fermer la modal en cas d'erreur pour éviter l'affichage de données incorrectes
      dispatch({ type: "SET_IS_MODAL_VISIBLE", payload: false });
    }
  };

  const userId = localStorage.getItem('login');


  const handleOk = async () => {

    if (loadingValid) return; // Empêche le double clic rapide
    setLoadingValid(true);

    try {
      const values = await form.validateFields(); // Valide les champs du formulaire

      const participantDetails = state.participantDetails || { categprof: 'N/A' };
      const actes = state.addedRows.map((row) => {
        const selectedActe = state.medicamentsData.find(
          (acte) => acte.codeacte === row.codeacte
        );

        return {
          Prestation: selectedActe ? { ...selectedActe } : {},
          ajustmt: 0,
          codeprest: "",
          fexclus: 0,
          freel: row.freel,
          intitule: "",
          numdoc: "",
          numligne: null,
          numligne_acte: selectedActe ? selectedActe.codeacte : null,
          prix_unitaire: row.prix_unitaire,
          qpassur: 0,
          qpmut: 0,
          qte: row.qte,
          ticket: 0,
        };
      });

      const docData = {
        actes,
        categprof: participantDetails.categprof,
        codefourn: values.codefourn,
        codeprest: "06",
        codesoc: values.codesoc,
        codepresc: values.codepresc,
        datepresc: values.datepresc,
        matribenef: values.matribenef,
        matripart: values.matripart,
        montdoc: values.montdoc,
        nbarticle: values.nbarticle,
        numdoc: isBonManuel ? values.numdoc : null,
        datedoc: isBonManuel ? values.datedoc?.format("YYYY-MM-DD") : null,
        remb_integral: values.remb_integral,
        typebenef: values.typebenef,
        typedoc: "BPI",
        user_id: userId,
      };

      const response = await bpiService.AddDoc(docData);

      if (response.Added === false) {
        api.error({
          message: "Erreur",
          description: "Numéro de bon déjà ajouté.",
        });
      } else {
        fetchDataByOption(state.selectedOption);
        resetFormData();
        api.success({
          message: "Succès",
          description: "Le document a été ajouté avec succès.",
        });
      }
    } catch (error) {
      if (error.errorFields) {
        api.error({
          message: "Validation échouée",
          description: "Veuillez remplir tous les champs obligatoires.",
        });
      } else {
        api.error({
          message: "Erreur",
          description: "Erreur lors de l'ajout du document: " + error.message,
        });
      }
    } finally {
      setLoadingValid(false);
    }
  };


  const handleModif = () => {
    form
      .validateFields()
      .then(async (values) => {

        const actes = state.addedRows.map((row) => {
          const selectedActe = state.medicamentsData.find(
            (acte) => acte.codeacte === row.codeacte
          );

          return {
            Prestation: selectedActe ? { ...selectedActe } : {},
            ajustmt: 0,
            codeprest: "",
            fexclus: 0,
            freel: row.freel,
            intitule: "",
            numdoc: "",
            numligne: null,
            numligne_acte: selectedActe ? selectedActe.codeacte : null,
            prix_unitaire: row.prix_unitaire,
            qpassur: 0,
            qpmut: 0,
            qte: row.qte,
            ticket: 0,
          };
        });
        const docData = {
          actes,
          categprof: state.selectedRowData.categprof,
          codefourn: values.codefourn,
          codeprest: "06",
          codesoc: values.codesoc,
          codepresc: values.codepresc,
          datepresc: values.datepresc,

          matribenef: values.matribenef,
          matripart: values.matripart,
          nbarticle: values.nbarticle,
          montdoc: values.montdoc,
          datedoc: state.selectedRowData.datedoc,
          numdoc: state.selectedRowData.numdoc,
          remb_integral: values.remb_integral,
          typebenef: values.typebenef,
          typedoc: "BPI",
          user_id: userId,
        };
        try {
          await bpiService.UpdateDetailBpi(docData);
          fetchDataByOption(state.selectedOption);
          handleCloseModal()
          api.success({
            message: "Succès",
            description: "Le document a été modifié avec succès.",
          });

        } catch (error) {
          api.error({
            message: "Erreur",
            description: "Erreur lors de l'ajout du document",
          });
        }
      })
      .catch((info) => {
        api.error({
          message: "Validation échouée",
          description: info,
        });
      });
  };

  const formatNumberWithSeparator = (number) => {
    return number ? number.toLocaleString() : '0'; // Vérifiez que number est défini avant d'utiliser toLocaleString
  };

  return (
    <div>
      {notificationHolder}
      <Card>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: "40px" }}
        >
          <Col>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 20px",
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                borderRadius: 10,
                boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
              }}
            >
              <MedicineBoxOutlined style={{ fontSize: 22, color: "#fff" }} />
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#fff",
                  letterSpacing: 0.5,
                  margin: 0,
                }}
              >
                Bons de Pharmacies
              </span>
            </div>
          </Col>
          <Col>
            <Select
              className="select-colored-accent"
              style={{
                width: 100,
                marginRight: 10,
                "--select-accent": "#1890ff",
                "--select-accent-bg": "#e6f4ff",
                "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
              }}
              onChange={handleYearChange}
              value={state.selectedYear}
              showSearch

            >
              {state.years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>

            <Select
              className="select-colored-accent"
              style={{
                width: 200,
                marginRight: 10,
                "--select-accent": "#722ed1",
                "--select-accent-bg": "#f9f0ff",
                "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
              }}
              onChange={handleSelectChange}
              value={state.selectedOption}
              showSearch
            >
              <Option value="AA">Tous les Documents</Option>
              <Option value="OK">Traité</Option>
              <Option value="KO">Non Traité</Option>
            </Select>
            <Input
              className="search-input-highlight"
              placeholder="Rechercher..."
              allowClear
              prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
              style={{
                width: 200,
                marginRight: 10,
              }}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <Button
              className="buttonRecep"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(false)}
              icon={<PlusCircleOutlined />}
            >
              Bon de prise en charge
            </Button>
            <Button
              className="ButtonbonManuel"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(true)}
              icon={<PlusCircleOutlined />}
            >
              Bon Facturé
            </Button>

            <Dropdown
              overlay={
                <Menu
                  style={{
                    borderRadius: 10,
                    overflow: "hidden",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                    padding: "4px 0",
                    minWidth: 240,
                  }}
                >
                  <Menu.Item
                    key="refresh"
                    icon={<SyncOutlined spin={state.isRefreshing} style={{ color: "#1890ff" }} />}
                    disabled={state.isRefreshing}
                    onClick={handleRefresh}
                  >
                    Actualiser
                  </Menu.Item>
                  <Menu.Item
                    key="export"
                    icon={<ExportOutlined style={{ color: "#1890ff" }} />}
                    onClick={handleExportClick}
                  >
                    Export
                  </Menu.Item>
                  <Menu.Item
                    key="import"
                    icon={<ImportOutlined style={{ color: "#1890ff" }} />}
                    onClick={handleOpenImportModal}
                  >
                    Import
                  </Menu.Item>
                  <Menu.Divider />
                  <Menu.Item
                    key="deleteSelected"
                    icon={<DeleteFilled style={{ color: "#f5222d" }} />}
                    danger
                    disabled={selectedDocuments.length === 0}
                    onClick={handleDeleteSelectedDocuments}
                  >
                    Supprimer la sélection {selectedDocuments.length > 0 ? `(${selectedDocuments.length})` : ""}
                  </Menu.Item>
                </Menu>
              }
              placement="bottomRight"
              trigger={["click"]}
            >
              <Button
                className="buttonRefresh"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  verticalAlign: "middle",
                  gap: 6,
                  fontWeight: 500,
                  borderRadius: 8,
                }}
              >
                Actions <DownOutlined />
              </Button>
            </Dropdown>
          </Col>
        </Row>
        <TableDOc
          bordered
          dataSource={state.filteredData}
          isPharmacieComponent={true}
          showAdditionalColumns={state.selectedOption === "OK"}
          handleDeleteline={handleDeleteline}
          onEdit={handleEdit}
          loading={state.loading}
          onSelectionChange={(keys, rows) => setSelectedDocuments(rows)}
          onFilteredDataChange={setColumnFilteredData}
        />
        <Modal
          open={isImportModalVisible}
          onCancel={handleCloseImportModal}
          title="Importer des bons depuis un fichier Excel"
          width="90%"
          style={{ maxWidth: 800 }}
          footer={
            importResults ? (
              <Button onClick={handleCloseImportModal}>Fermer</Button>
            ) : (
              [
                <Button key="cancel" onClick={handleCloseImportModal}>
                  Annuler
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={handleConfirmImport}
                  disabled={importRows.length === 0 || importErrors.length > 0}
                  loading={isImporting}
                >
                  {`Importer${importRows.length > 0 ? ` (${importRows.length})` : ""}`}
                </Button>,
              ]
            )
          }
        >
          {!importResults && (
            <>
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
                message="Format du fichier attendu"
                description={
                  <div>
                    <p style={{ marginBottom: 4 }}>
                      Fichier Excel (.xlsx) dont la première ligne contient exactement les
                      colonnes suivantes, dans cet ordre :
                    </p>
                    <div style={{ overflowX: "auto" }}>
                      <table style={{ borderCollapse: "collapse", marginTop: 4 }}>
                        <tbody>
                          <tr>
                            {IMPORT_TEMPLATE_COLUMNS.map((col) => (
                              <td
                                key={col}
                                style={{
                                  border: "1px solid #91caff",
                                  padding: "4px 10px",
                                  background: "#fff",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <code>{col}</code>
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p style={{ marginTop: 8, marginBottom: 0 }}>
                      Toutes les cellules doivent être renseignées. Format de date attendu
                      pour <code>datedoc</code> : <code>YYYY-MM-DD</code> ou{" "}
                      <code>DD/MM/YYYY</code>.
                    </p>
                  </div>
                }
              />

              <Button icon={<UploadOutlined />} onClick={() => importFileInputRef.current?.click()}>
                Sélectionner un fichier Excel
              </Button>
              <input
                type="file"
                ref={importFileInputRef}
                style={{ display: "none" }}
                accept=".xlsx, .xls"
                onChange={handleImportFileChange}
              />

              {importErrors.length > 0 && (
                <>
                  <Alert
                    type="error"
                    showIcon
                    style={{ marginTop: 16 }}
                    message={`${importErrors.length} anomalie(s) détectée(s) — corrigez le fichier puis réimportez-le`}
                    action={
                      <Button
                        size="small"
                        icon={<ExportOutlined />}
                        onClick={handleExportImportErrors}
                      >
                        Exporter les anomalies
                      </Button>
                    }
                  />
                  <Table
                    style={{ marginTop: 12 }}
                    size="small"
                    scroll={{ x: "max-content" }}
                    pagination={{ pageSize: 10 }}
                    dataSource={importErrors.map((err, idx) => ({ ...err, key: idx }))}
                    columns={[
                      { title: "Ligne Excel", dataIndex: "rowNum", width: 100 },
                      { title: "Colonne", dataIndex: "field", width: 140 },
                      { title: "Anomalie", dataIndex: "message" },
                    ]}
                  />
                </>
              )}

              {importRows.length > 0 && importErrors.length === 0 && (
                <Alert
                  type="success"
                  showIcon
                  style={{ marginTop: 16 }}
                  message={`${importRows.length} ligne(s) valide(s), prêtes à être importées.`}
                />
              )}
            </>
          )}

          {importResults && (
            <div>
              <Alert
                type={importResults.some((r) => !r.success) ? "warning" : "success"}
                showIcon
                style={{ marginBottom: 12 }}
                message={`${importResults.filter((r) => r.success).length} bon(s) importé(s) avec succès, ${importResults.filter((r) => !r.success).length} échec(s).`}
                action={
                  importResults.some((r) => !r.success) && (
                    <Button
                      size="small"
                      icon={<ExportOutlined />}
                      onClick={handleExportImportFailures}
                    >
                      Exporter les échecs
                    </Button>
                  )
                }
              />
              <Table
                size="small"
                scroll={{ x: "max-content" }}
                pagination={{ pageSize: 10 }}
                dataSource={importResults.map((r, idx) => ({ ...r, key: idx }))}
                columns={[
                  { title: "Ligne Excel", dataIndex: "rowNum", width: 100 },
                  { title: "N° Bon", dataIndex: "numdoc", width: 140 },
                  {
                    title: "Statut",
                    dataIndex: "success",
                    width: 100,
                    render: (success) =>
                      success ? (
                        <span style={{ color: "#389e0d", fontWeight: 600 }}>Réussi</span>
                      ) : (
                        <span style={{ color: "#cf1322", fontWeight: 600 }}>Échoué</span>
                      ),
                  },
                  { title: "Détail", dataIndex: "message" },
                ]}
              />
            </div>
          )}
        </Modal>
        <Modal
          open={state.isModalVisible}
          maskClosable={false}
          style={{ top: 20 }}
          footer={null}
          onCancel={handleCloseModal}
          destroyOnClose={true}
          width={1000}
          className="modal-header"

          title={
            <div>
              {state.isEdit
                ? "Modification bon de Pharmacie"
                : "Création Bon Pharmacie"}
              {state.isEdit && (
                <div style={{ fontSize: "14px", marginTop: "2px" }}>
                  Numéro :{" "}
                  {state.selectedRowData ? state.selectedRowData.numdoc : ""}
                </div>
              )}
            </div>
          }
        >
          {state.isModalLoading ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <Spin size="large" />
            </div>
          ) : (
            <Form
              form={form}
              layout="vertical"
              initialValues={state.selectedRowData}
              preserve={false}
            >
              <Divider orientation="left">
                Pharmacie
              </Divider>
              <Form.Item
                name="codefourn"
                label="Pharmacie"

              >
                <Select
                  style={{ width: "100%" }}
                  defaultValue={"--Selectionner"}
                  /*  disabled={
                     (!state.participantsData ||
                       state.isMatriculeSelectEnabled) &&
                     !state.isEdit
                   } */
                  showSearch
                  allowClear={true}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {state.pharmaciesData &&
                    state.pharmaciesData.map((pharmacie) => (
                      <Option
                        key={pharmacie.numFourn}
                        value={pharmacie.numFourn}
                      >
                        {`${pharmacie.numFourn} - ${pharmacie.raisoc}`}
                      </Option>
                    ))}
                </Select>
              </Form.Item>

              {isBonManuel && (
                <Row gutter={16}>

                  <Divider orientation="left">
                    Infos Bon
                  </Divider>

                  <>
                    <Col span={8}>
                      <Form.Item
                        name="numdoc"
                        label="Numéro Bon"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez entrer le numéro du bon",
                          },
                          {
                            pattern: /^[^/@#$]*$/,
                            message: "Le numéro du bon ne peut pas contenir les caractères suivants: / @ # $",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="datedoc"
                        label="Date Bon"
                        rules={[
                          {
                            required: true,
                            message: "Veuillez sélectionner la date du bon",
                          },
                        ]}
                      >
                        <DatePicker
                          disabledDate={(current) =>
                            current && current > dayjs().endOf("day")
                          }
                          format="DD/MM/YYYY"
                          style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item
                        name="montdoc"
                        label="Montant Bon"
                        initialValue={0}
                      >
                        <InputNumber style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </>
                </Row>
              )}


              <Row gutter={16}>

                <Col span={12}>

                  <Divider orientation="left">
                    Participant
                  </Divider>
                  <Form.Item
                    name="codesoc"
                    label="Société"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une société",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      onChange={handleSocieteChange}
                      disabled={state.isSocieteSelectEnabled && state.isEdit}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {state.adherents.map((adherent) => (
                        <Option
                          key={adherent.codeadht}
                          value={adherent.codeadht}
                        >
                          {`${adherent.codeadht} - ${adherent.intitule}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="matripart"
                    label="Matricule participant"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      disabled={
                        !state.participantsData ||
                        state.isMatriculeSelectEnabled
                      }
                      onChange={handleMatPartChange}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {state.participantsData &&
                        state.participantsData.map((participant) => (
                          <Option
                            key={participant.numcont}
                            value={participant.numcont}
                          >
                            {`${participant.matricule} - ${state.isEdit
                              ? participant.prenom + " " + participant.nom
                              : participant.part
                              }`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Divider orientation="left">
                    Prescripteur
                  </Divider>
                  <Form.Item name="codespe" label="Spécialités">
                    <Select
                      style={{ width: "100%" }}
                      onChange={handleFournisseurChange}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {state.specialitesData &&
                        state.specialitesData.map((specialite) => (
                          <Option
                            key={specialite.codespe}
                            value={specialite.codespe}
                          >
                            {`${specialite.codespe} - ${specialite.intitule}`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name="codepresc" label="Prescripteur">
                    <Select
                      style={{ width: "100%" }}
                      disabled={
                        !state.isPrescripteurSelectEnabled && !state.isEdit
                      }
                      allowClear={true}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {state.prescripteursData.map((prescripteur) => (
                        <Option
                          key={prescripteur.numFourn}
                          value={prescripteur.numFourn}
                        >
                          {`${prescripteur.numFourn} - ${prescripteur.raisoc}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Divider orientation="left">
                    Bénéficiaire
                  </Divider>
                  <Form.Item
                    name="typebenef"
                    label="Types"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select
                      style={{ width: "100%" }}
                      defaultValue="--Selectionner--"
                      onChange={handleTypeBenefChange}
                      disabled={!state.isMatriculeSelected && !state.isEdit}
                      value={state.selectedRowData?.libtype || undefined}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {state.benefsData &&
                        state.benefsData.map((benefData) => (
                          <Option
                            key={benefData.codetype}
                            value={benefData.codetype}
                          >
                            {benefData.libtype}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="matribenef"
                    label="Bénéficiaire"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner une option",
                      },
                    ]}
                  >
                    <Select
                      defaultValue="--Selectionner--"
                      style={{ width: "100%" }}
                      disabled={!state.isBeneficiaireSelected && !state.isEdit}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {(state.beneficiaires || []).map((beneficiaire) => (
                        <Option
                          key={beneficiaire.matribenef}
                          value={beneficiaire.matribenef}
                        >
                          {`${beneficiaire.matribenef} - ${beneficiaire.prenoms ? beneficiaire.prenoms + " " : ""
                            }${beneficiaire.nom ? beneficiaire.nom : ""}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>


                </Col>
                <Col span={12}>
                  <Divider orientation="left">
                    Ordonnance
                  </Divider>
                  <Row gutter={16}>
                    <Form.Item
                      name="nbarticle"
                      initialValue={0}
                      label="Nombre d'article"
                    >
                      <InputNumber
                        disabled={
                          !state.isPrescripteurSelectEnabled && !state.isEdit
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      name="datepresc"
                      label="Date d'ordonnance"
                      style={{ marginRight: "16px" }}
                    >
                      <DatePicker
                        disabledDate={(current) =>
                          current && current > dayjs().endOf("day")
                        }
                        disabled={
                          !state.isPrescripteurSelectEnabled && !state.isEdit
                        }
                        onChange={handleDateChange}
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                    <Form.Item
                      name="qteTotal"
                      label="quantité totale"
                      initialValue={0}
                    >
                      <InputNumber
                        disabled={
                          !state.isPrescripteurSelectEnabled && !state.isEdit
                        }
                      />
                    </Form.Item>
                  </Row>
                  <Form.Item name="codeacte">
                    <Select
                      style={{ width: "100%" }}
                      defaultValue="Saisir le médicament"
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                      disabled={
                        (!state.isPrescripteurSelectEnabled ||
                          !state.isDateSelected) &&
                        !state.isEdit
                      }
                      onChange={handleMedoc}
                    >
                      {state.medicamentsData &&
                        state.medicamentsData.map((medicament) => (
                          <Option
                            key={medicament.codeacte}
                            value={medicament.codeacte}
                          >
                            {`${medicament.libacte} `}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item
                        name="qte"
                        label="Qté"
                        className={
                          state.isSaisirMedicamentClicked ? "" : "hidden"
                        }
                        initialValue={1}
                      >
                        <InputNumber />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name="prix_unitaire"
                        label="P.U"
                        className={
                          state.isSaisirMedicamentClicked ? "" : "hidden"
                        }
                        initialValue={0}
                      >
                        <InputNumber />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <PlusCircleOutlined
                        style={{
                          fontSize: "30px",
                          paddingTop: "30px",
                          color: "#4DBD74",
                        }}
                        className={
                          state.isSaisirMedicamentClicked ? "" : "hidden"
                        }
                        onClick={handleAddRow}
                      />
                      <CloseCircleFilled
                        style={{
                          fontSize: "30px",
                          paddingTop: "30px",
                          paddingLeft: "8px",
                          color: "#ff2317",
                        }}
                        className={
                          state.isSaisirMedicamentClicked ? "" : "hidden"
                        }
                        onClick={handleClearTable}
                      />
                    </Col>
                  </Row>
                  {state.isTableVisible && state.addedRows.length > 0 && (
                    <Table
                      style={{
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}
                      className="custom-header1-table"
                      bordered
                      dataSource={[...state.addedRows]}
                      scroll={{ x: true }}
                      columns={[
                        {
                          title: "N°",
                          dataIndex: "numero",
                          key: "numero",
                          align: "center",
                        },
                        {
                          title: "Nom",
                          dataIndex: "libacte",
                          key: "libacte",
                        },
                        {
                          title: "Qt",
                          dataIndex: "qte",
                          key: "qte",
                          align: "center",
                        },
                        {
                          title: "P.U",
                          dataIndex: "prix_unitaire",
                          key: "prix_unitaire",
                          align: "right",
                          render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
                        },
                        {
                          title: "Montant",
                          dataIndex: "freel",
                          key: "freel",
                          align: "right",
                          render: (text) => <strong>{formatNumberWithSeparator(text)}</strong>,
                        },

                        {
                          title: "Exclus",
                          dataIndex: "exclus",
                          key: "exclus",
                          align: "center",
                          render: (text, record) => (
                            <Checkbox checked={record.exclus} />
                          ),
                        },
                        {
                          title: (
                            <div
                              style={{
                                backgroundColor: "#010f1c",
                                color: "white",
                                padding: "1px",
                              }}
                            ></div>
                          ),
                          dataIndex: "actions",
                          key: "actions",
                          align: "center",
                          fixed: "right",
                          render: (text, record) => (
                            <span>
                              <Popconfirm
                                title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
                                onConfirm={() => handleDelete(record)}
                                okText="Oui"
                                cancelText="Non"
                              >
                                <Tooltip title="Supprimer">
                                  <DeleteFilled
                                    style={{ cursor: "pointer", color: "red" }}
                                  />
                                </Tooltip>
                              </Popconfirm>
                            </span>
                          ),
                        },
                      ]}
                      summary={(pageData) => {
                        let totalFreel = 0;
                        pageData.forEach((item) => {
                          totalFreel += item.freel;
                        });
                        return (
                          <Table.Summary.Row align="right" justify>
                            <Table.Summary.Cell index={0}>
                              <strong>Total</strong>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1}></Table.Summary.Cell>
                            <Table.Summary.Cell index={2}></Table.Summary.Cell>
                            <Table.Summary.Cell index={3}></Table.Summary.Cell>
                            <Table.Summary.Cell index={4}>
                              <Text>
                                <strong>{formatNumberWithSeparator(totalFreel)}</strong>
                              </Text>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        );
                      }}
                    />
                  )}
                </Col>
              </Row>
              <div
                style={{
                  marginTop: "20px",
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Form.Item name="remb_integral" style={{ marginBottom: 0 }} valuePropName="checked">

                  <Checkbox>Remboursement Intégral</Checkbox>

                </Form.Item>
                <Button
                  type="dashed"
                  danger
                  onClick={handleCloseModal}
                  style={{ marginRight: 12 }}
                >
                  Fermer
                </Button>
                {state.isEdit ? (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#010f1c" }}
                    onClick={handleModif}
                  >
                    Modifier
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#010f1c" }}
                    onClick={handleOk}
                  >
                    Valider
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Modal>
        <Modal
          open={isParticipantInactive}
          title="Participant inactif!"
          onCancel={() => {
            setIsParticipantInactive(false);
            setSelectedParticipant(null);
          }}
          footer={
            userProfil === 'role_1' || userProfil === 'role_2' ? (
              [
                <Button key="cancel" onClick={() => {
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                  form.resetFields(['matripart']);
                }}>
                  Annuler
                </Button>,
                <Button key="confirm" type="primary" onClick={async () => {
                  try {
                    const benefData = await participantsIpmService.getBenefParticipant(selectedParticipant.numcont);
                    dispatch({ type: "SET_IS_MATRICULE_SELECTED", payload: true });
                    dispatch({ type: "SET_ALL_BENEFICIAIRES", payload: benefData });
                    dispatch({ type: "SET_BENEFICIAIRES", payload: benefData });
                    dispatch({ type: "SET_IS_BENEFICIAIRE_SELECTED", payload: false });
                    dispatch({ type: "SET_PARTICIPANT_DETAILS", payload: selectedParticipant });
                    form.setFieldsValue({
                      codetype: undefined,
                      matribenef: undefined,
                    });
                  } catch (error) {
                    notification.error({
                      message: "Erreur",
                      description: "Erreur lors de la récupération des bénéficiaires",
                    });
                  } finally {
                    setIsParticipantInactive(false);
                    setSelectedParticipant(null);
                  }
                }}>
                  Valider
                </Button>
              ]
            ) : (
              [
                <Button key="ok" type="primary" onClick={() => {
                  setIsParticipantInactive(false);
                  setSelectedParticipant(null);
                  form.resetFields(['matripart']);
                }}>
                  Ok
                </Button>
              ]
            )
          }
        >
          <p>Participant inactif! Veuillez confirmer cette opération.</p>
        </Modal>


      </Card>
    </div>
  );
};

export default BonsPharma;
